// extracted by mini-css-extract-plugin
module.exports = {"logoWrap":"Logo_logoWrap__VlfST","logoLink":"Logo_logoLink__28mGl","logo":"Logo_logo__1NmY1"};